import Typography from '@ixigo/iui/Typography';
import cn from '@repo/shared/utils/cn';
import type { FuelType } from '@/api';

const FuelTypeChipColorMap: Partial<
	Record<NonNullable<FuelType>, { color: string; bgColor: string }>
> = {
	ELECTRIC: {
		color: 'text-success-solid',
		bgColor: 'bg-success-solid',
	},
	CNG: {
		color: 'text-warning-solid',
		bgColor: 'bg-warning-solid',
	},
};

export function getFuelChipStyle(fuelType: Partial<FuelType>) {
	if (!fuelType || !FuelTypeChipColorMap[fuelType.toUpperCase() as FuelType]) {
		return undefined;
	}
	return FuelTypeChipColorMap[fuelType.toUpperCase() as FuelType];
}

export const FuelTypeChip = ({
	fuelType,
	className,
}: {
	fuelType: FuelType;
	className?: string;
}) => {
	const fuelChipStyle = getFuelChipStyle(fuelType);
	if (!fuelChipStyle) {
		return null;
	}
	return (
		<div
			className={cn(
				'flex items-center justify-center w-full py-px shrink-0',
				fuelChipStyle.bgColor,
				className,
			)}
		>
			<Typography variant="body-2xs" className={cn(fuelChipStyle.color)}>
				{fuelType}
			</Typography>
		</div>
	);
};
